import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const StaticGalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Gallery images data (42 images)
  const galleryImages = Array.from({ length: 42 }, (_, index) => ({
    id: index + 1,
    src: `/gallery/PG_${index + 1}_BIG.jpg`,
    title: `Baseball Image ${index + 1}`
  }));

  useEffect(() => {
    document.title = 'Gallery | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
    
    const cssFiles = [
      'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
      '/css/screen_layout_mega.css',
      '/css/default.css', 
      '/css/component.css',
      '/css/slimmenu.css'
    ];

    cssFiles.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.head.appendChild(script);
      });
    };

    const initializeMenu = async () => {
      try {
        await loadScript('/js/jquery.min.js');
        await loadScript('/js/jquery.slimmenu.js');
        
        setTimeout(() => {
          if (window.$ && typeof window.$.fn.slimmenu === 'function') {
            window.$('ul.slimmenu').slimmenu({
              resizeWidth: '1100',
              collapserTitle: 'Main Menu',
              easingEffect: 'easeInOutQuint',
              animSpeed: 'medium',
              indentChildren: true,
              childrenIndenter: '&raquo;'
            });
          }
        }, 300);
      } catch (error) {
        console.error('Error loading scripts:', error);
      }
    };

    initializeMenu();

    return () => {
      if (window.$ && window.$('ul.slimmenu').length > 0) {
        try {
          window.$('ul.slimmenu').off();
        } catch (e) {}
      }
    };
  }, []);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    if (selectedImage) {
      const currentIndex = selectedImage.id - 1;
      let newIndex;
      
      if (direction === 'next') {
        newIndex = (currentIndex + 1) % galleryImages.length;
      } else {
        newIndex = currentIndex === 0 ? galleryImages.length - 1 : currentIndex - 1;
      }
      
      setSelectedImage(galleryImages[newIndex]);
    }
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedImage) {
        if (e.key === 'ArrowRight') {
          navigateImage('next');
        } else if (e.key === 'ArrowLeft') {
          navigateImage('prev');
        } else if (e.key === 'Escape') {
          closeModal();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage]);

  return (
    <div id="outer_m">
      {/* Header */}
     <PublicHeader />

      {/* Main Content */}
      <div id="main">
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#022a5e'}}></i>
        </div>

        <div id="outercent">
          <h3 className="heading_cet">Photo Gallery</h3>
          
          <div id="outercentinner">
            <div id="gallery1" className="lbGallery">
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center'
              }}>
                {galleryImages.map((image) => (
                  <li key={image.id} style={{
                    margin: '5px',
                    display: 'inline-block'
                  }}>
                    <a 
                      href="#" 
                      onClick={(e) => {
                        e.preventDefault();
                        handleImageClick(image);
                      }}
                      title={image.title}
                    >
                      <img 
                        src={image.src} 
                        className="gal_img" 
                        alt={image.title}
                        style={{
                          width: '200px',
                          height: '200px',
                          objectFit: 'cover',
                          cursor: 'pointer',
                          border: '2px solid #ddd',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => {
                          e.target.style.border = '2px solid #0076a3';
                          e.target.style.transform = 'scale(1.05)';
                        }}
                        onMouseOut={(e) => {
                          e.target.style.border = '2px solid #ddd';
                          e.target.style.transform = 'scale(1)';
                        }}
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }} onClick={closeModal}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('prev');
            }}
            style={{
              position: 'absolute',
              left: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: '40px',
              cursor: 'pointer',
              padding: '0 20px',
              zIndex: 10000
            }}
          >
            <i className="fa fa-chevron-left"></i>
          </button>

          <img
            src={selectedImage.src}
            alt={selectedImage.title}
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              objectFit: 'contain'
            }}
            onClick={(e) => e.stopPropagation()}
          />

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('next');
            }}
            style={{
              position: 'absolute',
              right: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: '40px',
              cursor: 'pointer',
              padding: '0 20px',
              zIndex: 10000
            }}
          >
            <i className="fa fa-chevron-right"></i>
          </button>

          <button
            onClick={closeModal}
            style={{
              position: 'absolute',
              top: '20px',
              right: '40px',
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: '40px',
              cursor: 'pointer',
              zIndex: 10000
            }}
          >
            <i className="fa fa-times"></i>
          </button>
        </div>
      )}

      {/* Footer */}
       <PublicFooter />
    </div>
  );
};

export default StaticGalleryPage;